var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "choose-fee-container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "mobile-card",
            [
              _c("template", { slot: "title" }, [
                _c("span", [_vm._v(_vm._s(_vm.selectItem.itemName))])
              ]),
              _c("template", { slot: "content" }, [
                _vm.selectIntervalName
                  ? _c("div", { staticClass: "flex-form-info" }, [
                      _c("span", [_vm._v("交费区间")]),
                      _c(
                        "span",
                        {
                          staticClass: "custom-select-item",
                          on: { click: _vm.selectRange }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatSelectSpaceText")(
                                  _vm.model.rangeName
                                )
                              ) +
                              " "
                          ),
                          _c("van-icon", { attrs: { name: "arrow-down" } })
                        ],
                        1
                      )
                    ])
                  : _c("div", { staticClass: "flex-form-info" }, [
                      _c("span", [_vm._v("交费区间")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("formatSpaceText")(_vm.model.rangeName))
                        )
                      ])
                    ]),
                _vm.selectMoney
                  ? _c("div", { staticClass: "flex-form-info" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.selectItem.canChangeCount ? "单价" : "收费金额"
                          )
                        )
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "money-item",
                          on: { click: _vm.selectPrice }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.model.name +
                                  "(" +
                                  _vm.formatMoney(_vm.model.money) +
                                  ")"
                              ) +
                              " "
                          ),
                          _c("van-icon", { attrs: { name: "arrow-down" } })
                        ],
                        1
                      )
                    ])
                  : _vm.editMoney
                  ? _c("div", { staticClass: "flex-form-info" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.selectItem.canChangeCount ? "单价" : "收费金额"
                          )
                        )
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "input-border",
                          attrs: { "data-tootik": _vm.editMoneyPlaceholder }
                        },
                        [
                          _vm.selectItem.feeMode === 3 &&
                          _vm.selectItem.maxMoney
                            ? _c("vue-numeric", {
                                staticClass: "money-input",
                                attrs: {
                                  max: _vm.selectItem.maxMoney,
                                  precision: 2
                                },
                                model: {
                                  value: _vm.model.money,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "money", $$v)
                                  },
                                  expression: "model.money"
                                }
                              })
                            : _c("vue-numeric", {
                                staticClass: "money-input",
                                attrs: { precision: 2 },
                                model: {
                                  value: _vm.model.money,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "money", $$v)
                                  },
                                  expression: "model.money"
                                }
                              })
                        ],
                        1
                      )
                    ])
                  : _c("div", { staticClass: "flex-form-info" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.selectItem.canChangeCount ? "单价" : "收费金额"
                          )
                        )
                      ]),
                      _c("span", { staticClass: "money-item" }, [
                        _vm._v(_vm._s(_vm._f("formatMoney")(_vm.model.money)))
                      ])
                    ]),
                _vm.editCount
                  ? _c(
                      "div",
                      { staticClass: "flex-form-info" },
                      [
                        _c("span", [_vm._v("数量")]),
                        _c("van-stepper", {
                          model: {
                            value: _vm.model.count,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "count", $$v)
                            },
                            expression: "model.count"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c("choose-fee-footer", {
            attrs: { model: _vm.model },
            on: { commit: _vm.onCommit }
          })
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showRangePicker,
            callback: function($$v) {
              _vm.showRangePicker = $$v
            },
            expression: "showRangePicker"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              columns: _vm.intervalArray,
              "default-index": _vm.defaultIndex
            },
            on: {
              cancel: function($event) {
                _vm.showRangePicker = false
              },
              confirm: _vm.onConfirm
            }
          })
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showMoneyPicker,
            callback: function($$v) {
              _vm.showMoneyPicker = $$v
            },
            expression: "showMoneyPicker"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              columns: _vm.moneyArray,
              "default-index": _vm.defaultIndex2
            },
            on: {
              cancel: function($event) {
                _vm.showMoneyPicker = false
              },
              confirm: _vm.onConfirm2
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }